import {Input, Radio, Select, Textarea} from "./inputs/index.js";
import InputNumeric from "./inputs/InputNumeric.jsx";
import {Icons} from "./Icons.jsx";
import SelectDictSearch from "./inputs/SelectDictSearch.jsx";
import DateTime from "./inputs/DateTime.jsx";
import {CheckList} from "./CheckList.jsx";
import MultiSelectList from "./inputs/MultiSelectList.jsx";


export const componentTypeMatcher = {

    text: {
        component: <Input/>,
    },
    textarea: {
        component: <Textarea/>,
    },

    radio: {
        component: <Radio/>,
    },
    numeric: {
        component: <InputNumeric/>,
    },

    select: {

        component: <Select/>,
    },
    selectSearch: {
        component: <SelectDictSearch/>,
    },
    datetime: {
        component: <DateTime
            format={'YYYY-MM-DD HH:mm'}
        />
    },
    date: {
        component: <DateTime
            hideTime={true}
            format={'YYYY-MM-DD'}
        />
    },
    checklist: {
        component: <CheckList/>
    },


    multiSelect: {
        component: <MultiSelectList
            hideSelectAll
            queryId={'matcher'}
        />

    },

}


export const iconMatcher = {
    user: {
        icon: <Icons.user size={26}/>,
    },
    cogs: {
        icon: <Icons.cogs size={26}/>,
    },
    help: {
        icon: <Icons.help size={26}/>,
    },
}